export const PREFIX_KIND = {
  fax: 'fax',
  patient_documents: 'doc',
  form_response_store: 'form'
};

export const REVERSE_PREFIX_KIND = Object.entries(PREFIX_KIND).reduce((acc, [key, value]) => {
  acc[value] = key;
  return acc;
}, {});

export const formatViewDocument = (document, categories) => ({
  ...document,
  load: true,
  title: document?.name,
  handle: document?.document_handle || {
    response_id: document?.id,
    appointment_id: document?.appointment_id,
    form_id: document?.form_id,
    json: document?.json,
    form_json: document?.form_json,
    form_version: document?.form_version
  },
  category: categories.find((cat) => cat?.value == document?.category?.trim()),
  type: document?.kind === 'fax' ? 'fax' : document?.mimetype || 'form',
  id: document?.id,
  patient_id: document?.patient_id,
  uploader_id: document?.uploader_id,
  appointment_id: document?.appointment_id
});
